import { useFieldValue } from "components/form/input/NestedField";
import TextInput from "components/form/input/TextInput";
import ApontamentoCommonFields from "entity/Indicador/components/apontamento/fields/ApontamentoCommonFields";
import ApontamentoImages from "entity/Indicador/components/apontamento/fields/ApontamentoImages";
import ApontamentoClienteParams, {
    ApontamentoParamItem,
} from "entity/Indicador/components/apontamento/fields/ApontamentoClienteParams";
import ApontamentoAmostraParams, {
    useTipoApontamento,
} from "entity/Indicador/components/apontamento/fields/ApontamentoAmostraParams";
import ApontamentoResultado from "entity/Indicador/components/apontamento/fields/ApontamentoResultado";
import ApontamentoObservacao from "entity/Indicador/components/apontamento/fields/ApontamentoObservacao";
import { useEffect } from "react";
import IndicadorEntity from "..";
import FormRow from "components/form/FormRow";
import Insumo from "entity/Insumo";
import EntitySearchInput from "components/form/EntitySearch/EntitySearchInput";
import GeolocationButton from "components/form/input/GeolocationButton";
import TTPColetas from "./TTPColetas";
import { useCoordinates } from "util/geolocation";
import { useForm } from "react-final-form";
import SelectInput from "components/form/input/SelectInput";
import { ApontamentoColetas } from "entity/Indicador/components/apontamento/fields";
import Operador from "entity/Operador";

export default function EditFields({ visita, isNew, TipoClass }) {
    const [tipo] = useTipoApontamento();

    const params = visita.cliente.getParams(IndicadorEntity, tipo, TipoClass);
    const paramItems = visita.cliente.getParamItems(IndicadorEntity, tipo);
    const [coordinates] = useCoordinates();
    const [apontamento, setApontamento] = useFieldValue();
    const form = useForm();

    useEffect(() => {
        if (apontamento) {
            apontamento.conformidade = IndicadorEntity.calcConformidade(apontamento, params, setApontamento);
            form.change("conformidade", IndicadorEntity.calcConformidade(apontamento, params, setApontamento));
            if (isNew && !apontamento.georeferencia) {
                apontamento.georeferencia = coordinates;
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [apontamento, coordinates, isNew, params, setApontamento]);

    return (
        <>
            <ApontamentoCommonFields visita={visita} TipoClass={TipoClass} showVariedade />
            <ApontamentoAmostraParams>
                <FormRow>
                    <EntitySearchInput name="insumo" label="Insumo" EntityClass={Insumo} />
                </FormRow>
                <FormRow>
                    <EntitySearchInput name="variedade" label="Variedade" EntityClass={Insumo} />
                </FormRow>
                <FormRow>
                    <GeolocationButton name="georeferencia" />
                </FormRow>
                <FormRow>
                    <EntitySearchInput
                        name="operador"
                        label="Operador"
                        EntityClass={Operador}
                        extraQuery={(query) => query.where("cliente.uid", "==", visita.data.cliente.uid)}
                    />
                </FormRow>
                <FormRow>
                    <SelectInput name="turno" label="Turno" options={["A", "B", "C"]} required />
                </FormRow>
            </ApontamentoAmostraParams>

            <ApontamentoClienteParams params={params}>
                {params ? (
                    <>
                        <ApontamentoParamItem label="Tamanho (min. e max.):">
                            ({params.intervaloMin}, {params.intervaloMax})
                        </ApontamentoParamItem>
                        <ApontamentoParamItem label="Meta (%):">{params.meta}</ApontamentoParamItem>
                    </>
                ) : null}
            </ApontamentoClienteParams>
            {apontamento.coletas &&
            apontamento.coletas.length > 0 &&
            apontamento.coletas.filter((c) => c.quantidade).length > 0 ? (
                <TTPColetas visita={visita} paramItems={paramItems} /> // é registro antigo
            ) : (
                <ApontamentoColetas visita={visita}>
                    <TextInput type="number" name="tolete" label="Tolete" />
                    <TextInput name="conforme" label="Conforme" disabled />
                </ApontamentoColetas>
            )}
            <ApontamentoResultado>
                <TextInput name="totalToletes" label="Total de Toletes Picados" disabled />
            </ApontamentoResultado>

            <ApontamentoObservacao />
            <ApontamentoImages visita={visita} />
        </>
    );
}
